import React, { type ReactNode } from 'react';
import type { FieldType } from '../../../types/EvalancheTypes';
import { Label, Container, ErrorMessage, RadioButton, RadioInput, RadioLabel } from '../styles';

export const RadioButtons = ({
  field,
  formikProps,
}: {
  field: FieldType;
  formikProps: any;
}): ReactNode => {
  const options = Array.isArray(field.options) ? field.options : Object.values(field.options || {});
  return (
    <Container>
      <Label>{field.label}</Label>
      {options?.map((option: any) => (
        <RadioButton key={option.key}>
          <RadioLabel htmlFor={option.key}>
            <RadioInput
              type="radio"
              id={option.key}
              value={option.key.toString()}
              name={field.name}
              checked={formikProps.values[field.name] === option.value}
              onChange={() => formikProps.setFieldValue(field.name, option.key.toString())}
              data-test={`radio-${option.value}`}
              readOnly={field.readonly}
            />
            <span>{option.value}</span>
          </RadioLabel>
        </RadioButton>
      ))}

      {formikProps.errors[field.name] && (
        <ErrorMessage data-test={`radio-${field.name}-error`}>
          {formikProps.errors[field.name]}
        </ErrorMessage>
      )}
    </Container>
  );
};
